<div class="modal-main-error">
  <div class="close-modal">
    <button
      mat-icon-button
      aria-label="close modal"
      mat-dialog-close
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-header-container">
    <h2>Permission Required</h2>
  </div>

  <mat-dialog-content class="message-container">
    <p>
      Sorry, you do not have permission to view this page. Ask your store
      owner or manager for access to Account Balance.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-flat-button color="primary" mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
